import Authentication from '../../Authentication'
import ServiceCaller from "../../services/ServiceCaller";
import UserService from "../../services/User";
const service = new UserService()

// Load user information
const state = {
  error: "",
  inProgress: false,
  userDetails: null,
  displayName: null,
  email: null,
  accessToken: null,
}
const mutations = {
  setError: (state, value) => {state.error = value},
  setInProgress: (state, value) => {state.inProgress = value},
  setUserDetails: (state, value) => {state.userDetails = value},}
const actions = {
  logout: () => Authentication.logout(),
  loadUserDetails: (context) => ServiceCaller.call(service.getUserDetails(), context.commit, 'setUserDetails', 'setError', 'setInProgress'),
}

const getters = {
  // userToken (state, getters, rootState) {}
  userEmail: () => Authentication.getUserEmail(),
  userToken: () => Authentication.getUserToken(),
  userDetails: (state) => {return state.userDetails},
  userID: (state) => { return ((state || {}).userDetails || {}).ID},
  isAdmin: (state) => {return (state.userDetails || {}).IsAdmin === true}
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
